export default __webpack_public_path__ + "static/share-card-ad0c07afd3b9cc469ed85294b3df1fce.png";